import React from 'react';

export default function MemberCard({ handleOnClick, info, isSelected = false }) {
  const getMemberDisplayName = memberInfo => {
    if (!memberInfo) return '';

    if (memberInfo.entity_structure?.entity_type?.code === 'JURISTIC') {
      return memberInfo.company_name_th || '';
    } else {
      const fullName = `${memberInfo.first_name_th || ''} ${memberInfo.last_name_th || ''}`.trim();
      return fullName === 'คุณ' ? '' : fullName;
    }
  };

  return (
    <div
      onClick={handleOnClick}
      className={`cursor-pointer pl-[min(1.50vw,15.35px)] pr-[min(1.00vw,10.29px)] flex items-center justify-between h-[min(5.25vw,53.76px)] rounded-[min(1.41vw,14.39px)] m-1 ${
        isSelected ? 'bg-[#FAFAFA] border-2 border-[var(--color-green)]' : 'bg-[#FFF]'
      } `}
    >
      <div className="flex items-center gap-[min(1.41vw,14.39px)] flex-1 min-w-0">
        <img
          className="object-cover aspect-square w-[min(3.74vw,38.3px)] h-fit rounded-full flex-shrink-0"
          src="/img/avatar-female.png"
          alt=""
        />
        <div className="text-10 flex-1 min-w-0">
          <div className="text-sm text-left truncate">{getMemberDisplayName(info)}</div>
          <div className="text-[var(--color-grey-2)] text-sm text-left">{info.phone_number}</div>
        </div>
      </div>
      <div className="flex items-center justify-center rounded-full prompt font-[300] bg-[var(--color-blue-2)] min-w-[min(7.80vw,79.89px)] h-[min(1.58vw,16.17px)] text-[#FFF] text-10 uppercase">
        {info.position || 'MEMBER'}
      </div>
    </div>
  );
}
